import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import NewsFeed from "../../home_components/NewsFeed";
import CardPodium from "../../home_components/CardPodium";
import ChampionsSection from "../../home_components/ChampionsSection";
import RecentPpvsSection from "../../home_components/RecentPpvsSection";

const Container = styled.div `
    width: 90%;
    height: 100%;
    margin: 0 auto;

    & h1 {
        margin: 0;
        text-align: center;
    }

    & p.description-text {
        font-weight: 700;
        color: white;
        margin: 10px 0;
        padding: 0;
        width: 100%;
        text-align: center;
        font-family: CameronSansMedium;
        font-size: 9px;
        letter-spacing: 3px;
    }
`;

const ExploreSectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  margin-bottom: 16px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
  }
`;

const ExploreSectionTitle = styled.h2`
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.16em;
  white-space: nowrap;
`;

const BoxAllCategories = styled.div `
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 50px;
    padding: 20px 0;
`;

const SingleSpaceCategory = styled.div `
    position: relative;
    width: calc(100% - 10px);
    height: calc(20% - 10px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px solid black;

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    &:hover {
        transform: scale(1.05);
        transition: transform 0.3s ease-in-out;
    }

`;

const BoxNameCategory = styled.div `
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 5px 10px;
        background-color: rgba(100, 98, 98, 0.5);

        & p {
            margin: 0;
            padding: 0;
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            text-align: center;
            letter-spacing: 2px;
            color: white;
        }
    `;

function MobileHomePageRender({listCategory}) {

    const navigate = useNavigate();
    return (
        <Container className="container-mobile-home-page-render">
            <p className='description-text'>
                La <a href="https://gwf.forumcommunity.net/" target="_blank" rel="noopener noreferrer">Global Wrestling Federation</a> è una eFed (Gioco di ruolo narrativo) nata nel 2005 e che continua ancora oggi ad essere attiva.
                Questo sito vuole raccogliere tutti i dati relativi a questo mondo, dando un interfaccia grafica a quanto presente nel forum.
            </p>

            <CardPodium isMobile />

            <NewsFeed isMobile />

            <ChampionsSection isMobile />

            <RecentPpvsSection isMobile />

            <ExploreSectionHeading>
                <ExploreSectionTitle>Esplora</ExploreSectionTitle>
            </ExploreSectionHeading>

            <BoxAllCategories className="box-all-categories">
                {listCategory.map((category, index) => (
                    <SingleSpaceCategory
                     key={index}
                     className="category-mobile-home-page-render"
                     onClick={() => navigate(category.link)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + category.img} alt={category.title} />
                        <BoxNameCategory className="box-name-category">
                            <p>{category.title}</p>
                        </BoxNameCategory>
                    </SingleSpaceCategory>
                ))}
            </BoxAllCategories>
        </Container>
    )
}

export default MobileHomePageRender;